/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%}.summary[_ngcontent-%COMP%]{width:100%;position:relative}.summary__row[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;margin-bottom:1rem}.summary__row[_ngcontent-%COMP%]:last-child{margin-bottom:2rem}.summary__col[_ngcontent-%COMP%]{width:calc(50% - .625rem);font-family:b-montserrat;font-size:1.5rem;color:#fdfd88}.summary__col[_ngcontent-%COMP%]:first-child{text-align:right;font-family:r-montserrat;font-size:1rem}"];
export { styles as styles };
